import axios from 'axios';
import React, { useState } from 'react';
import Navigation from '../components/Navigation';
// import { FaEyeSlash } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import base_url from '../config/Config';
// import { AiFillFile } from "react-icons/ai";
import Sidebar from '../components/Sidebar';

const AddFintech = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        fintech_id: '',
        fintech_name: '',
        account_number: '',
        ifsc_code: '',
        bank_name: '',
        processing_fee: '',
        commision: '',
        pan: '',
        cin_number: '',
        gst_number: '',
        director_name: '',
        pan_number: '',
        aadhar_number: '',
        spoc_name: '',
        spoc_phone_number: '',
        email_id: '',
        password: '',
        re_password: '',

    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            console.log('Form Data:', formData);

            // Make an API request to save data
            const response = await axios.post(`${base_url}/api1/user/userCreated`, {
                employeeId: formData.fintech_id,
                employeeName: formData.fintech_name,
                partnerAccountNumber: formData.account_number,
                ifscCode: formData.ifsc_code,
                bankName: formData.bank_name,
                processingFeePart: formData.processing_fee,
                commision: formData.commision,
                pan: formData.pan,
                cinNumber: formData.cin_number,
                gstNumber: formData.gst_number,
                directorName: formData.director_name,
                directorPan: formData.pan_number,
                directorAadhar: formData.aadhar_number,
                spocName: formData.spoc_name,
                spocMobileNumber: formData.spoc_phone_number,
                emailId: formData.email_id,
                createPassword: formData.password,
                confirmPassword: formData.re_password,
            });

            console.log('API Response:', response.data);

            // Handle the response as needed (e.g., show success message)
            window.alert('Company Create successfully');

            // Optionally, you can reset the form after successful submission
            setFormData({
                fintech_id: '',
                fintech_name: '',
                account_number: '',
                ifsc_code: '',
                bank_name: '',
                processing_fee: '',
                commision: '',
                pan: '',
                cin_number: '',
                gst_number: '',
                director_name: '',
                pan_number: '',
                aadhar_number: '',
                spoc_name: '',
                spoc_phone_number: '',
                email_id: '',
                password: '',
                re_password: '',
            });

            // Redirect to the list page
            navigate('/fintech/Fintech');
        } catch (error) {
            // Handle errors (e.g., show error message)
            console.error('Error saving data:', error);
        }
    };


    return (
        <>
            <div className='overviewsaa'>
                <h4>Add Fintech Partner</h4>
            </div>
            <div className='navigationss mb-5'>
                <Navigation />
            </div>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-lg-2 col-md-2 sidebarnavigartion'>
                        <div className='lmssidebar'>
                            <Sidebar />
                        </div>
                    </div>
                    <div className='col-lg-10 col-md-10 '>
                        <div className='personalhead text-justify mt-4'>
                            {/* <p>FIntech Details</p> */}
                        </div>
                        {/* <div className='row'>
                            <div className='col-md-12 col-lg-12'>
                                <div className='profileimage text-center mt-3'>
                                    <img src="../images/sample.jpg" alt="" width={150} height={150} />
                                </div>
                            </div>
                        </div> */}
                        <div className='dashboardlms mt-3 '>
                            <form action="" onSubmit={handleSubmit}>
                                <div className='row'>
                                    <div className='col-md-12 col-lg-12'>
                                        <div className='personaldetailsinformation mb-3'>
                                            <div className='row'>
                                            <div className='col-lg-3 col-md-3 col-3'>
                                                    <div className='personaldetails text-justify mt-3'>
                                                        <label htmlFor="fintech_id">Fintech ID</label><br />
                                                        <input type="text" name="fintech_id" id="fintech_id" placeholder='Partner ID' onChange={handleInputChange} />
                                                    </div>
                                                </div>
                                                <div className='col-lg-3 col-md-3 col-3'>
                                                    <div className='personaldetails text-justify mt-3'>
                                                        <label htmlFor="fintech_name">Fintech Name</label><br />
                                                        <input type="text" name="fintech_name" id="fintech_name" placeholder='Partner Name' onChange={handleInputChange} />
                                                    </div>
                                                </div>
                                                <div className='ol-lg-3 col-md-3 col-3'>
                                                    <div className='personaldetails text-justify mt-3'>
                                                        <label htmlFor="account_number">Partner Account Number</label><br />
                                                        <input type="text" name="account_number" id="account_number" placeholder='Account Number' onChange={handleInputChange} />
                                                    </div>
                                                </div>
                                                <div className='ol-lg-3 col-md-3 col-3'>
                                                    <div className='personaldetails text-justify mt-3'>
                                                        <label htmlFor="ifsc_code">IFSC Code</label><br />
                                                        <input type="text" name="ifsc_code" id="ifsc_code" placeholder='IFSC Code' onChange={handleInputChange} />
                                                    </div>
                                                </div>
                                                <div className='ol-lg-3 col-md-3 col-3'>
                                                    <div className='personaldetails text-justify mt-3'>
                                                        <label htmlFor="bank_name">Bank Name</label><br />
                                                        <input type="text" name="bank_name" id="bank_name" placeholder='Bank Name' onChange={handleInputChange} />
                                                    </div>
                                                </div>
                                                <div className='ol-lg-3 col-md-3 col-3'>
                                                    <div className='personaldetails text-justify mt-3'>
                                                        <label htmlFor="processing_fee">Processing Fee</label><br />
                                                        <input type="text" name="processing_fee" id="processing_fee" placeholder='Processing Fee' onChange={handleInputChange} />
                                                    </div>
                                                </div>
                                                <div className='ol-lg-3 col-md-3 col-3'>
                                                    <div className='personaldetails text-justify mt-3'>
                                                        <label htmlFor="commision">Commision</label> <br />
                                                        <input type="text" name="commision" id="commision" placeholder='Commision' onChange={handleInputChange} />
                                                    </div>
                                                </div>
                                                <div className='ol-lg-3 col-md-3 col-3'>
                                                    <div className='personaldetails text-justify mt-3'>
                                                        <label htmlFor="pan">PAN</label><br />
                                                        <input type="text" name="pan" id="pan" maximan={6} minimum={6} placeholder='PAN' onChange={handleInputChange} />
                                                    </div>
                                                </div>
                                                <div className='ol-lg-3 col-md-3 col-3'>
                                                    <div className='personaldetails text-justify mt-3'>
                                                        <label htmlFor="cin_number">CIN Number</label><br />
                                                        <input type="text" name="cin_number" id="cin_number" placeholder='CIN Number' onChange={handleInputChange} />
                                                    </div>
                                                </div>
                                                <div className='ol-lg-3 col-md-3 col-3'>
                                                    <div className='personaldetails text-justify mt-3'>
                                                        <label htmlFor="gst_number">GST Number</label><br />
                                                        <input type="text" name="gst_number" id="gst_number" placeholder='GST Number' onChange={handleInputChange} />
                                                    </div>
                                                </div>
                                                <div className='ol-lg-3 col-md-3 col-3'>
                                                    <div className='personaldetails text-justify mt-3'>
                                                        <label htmlFor="director_name">Director Name</label><br />
                                                        <input type="text" name="director_name" id="director_name" placeholder='Name' onChange={handleInputChange} />
                                                    </div>
                                                </div>
                                                <div className='ol-lg-3 col-md-3 col-3'>
                                                    <div className='personaldetails text-justify mt-3'>
                                                        <label htmlFor="pan_number">Director PAN</label><br />
                                                        <input type="text" name="pan_number" id="pan_number" placeholder='Pan Number' onChange={handleInputChange} />
                                                    </div>
                                                </div>
                                                <div className='ol-lg-3 col-md-3 col-3'>
                                                    <div className='personaldetails text-justify mt-3'>
                                                        <label htmlFor="aadhar_number">Director Aadhaar</label><br />
                                                        <input type="number" name="aadhar_number" id="aadhar_number" placeholder='Aadhar Number' onChange={handleInputChange} />
                                                    </div>
                                                </div>
                                                <div className='ol-lg-3 col-md-3 col-3'>
                                                    <div className='personaldetails text-justify mt-3'>
                                                        <label htmlFor="spoc_name">SPOC Name</label><br />
                                                        <input type="text" name="spoc_name" id="spoc_name" placeholder='SPOC Name' onChange={handleInputChange} />
                                                    </div>
                                                </div>
                                                <div className='ol-lg-3 col-md-3 col-3'>
                                                    <div className='personaldetails text-justify mt-3'>
                                                        <label htmlFor="spoc_phone_number">SPOC Phone Number</label><br />
                                                        <input type="number" name="spoc_phone_number" id="spoc_phone_number" placeholder='SPOC Phone Number' onChange={handleInputChange} />
                                                    </div>
                                                </div>
                                                <div className='ol-lg-3 col-md-3 col-3'>
                                                    <div className='personaldetails text-justify mt-3'>
                                                        <label htmlFor="email_id">Email Id</label><br />
                                                        <input type="mail" name="email_id" id="email_id" placeholder='Email Id' onChange={handleInputChange} />
                                                    </div>
                                                </div>
                                                <div className='ol-lg-3 col-md-3 col-3'>
                                                    <div className='personaldetails text-justify mt-3'>
                                                        <label htmlFor="password">Password</label><br />
                                                        <input type="password" name="password" id="password" placeholder='password' onChange={handleInputChange} />
                                                    </div>
                                                </div>
                                                <div className='ol-lg-3 col-md-3 col-3'>
                                                    <div className='personaldetails text-justify mt-3'>
                                                        <label htmlFor="re_password">Re-Password</label><br />
                                                        <input type="text" name="re_password" id="re_password" placeholder='Re password' onChange={handleInputChange} />
                                                    </div>
                                                </div>
                                                <div className='ol-lg-3 col-md-3 col-3'>
                                                    <div className='personaldetails text-justify mt-3'>
                                                        <label htmlFor="status">Status</label><br />
                                                        <select name="status" id="status" onChange={handleInputChange}>
                                                            <option value="Active">Active</option>
                                                            <option value="Deactive">Deactive</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-12 col-lg-12'>
                                        <div className='buttonss mt-3 mb-3 text-center'>
                                            <button type='submit' >Submit</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
export default AddFintech;
